// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__HQLYg","modalFooterButton":"ModalNotes_modalFooterButton__WZR9g"};